// extracted by mini-css-extract-plugin
export default {"result":"_IAGntSCP0ABOdOMyiTD","actions":"smH9GO7fMHF3WKEuf6lu"};